import { render, staticRenderFns } from "./Grammarwindow.vue?vue&type=template&id=566a0102"
import script from "./Grammarwindow.vue?vue&type=script&lang=js"
export * from "./Grammarwindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports